import React, { useContext, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Icon, TooltipHost } from '@fluentui/react';
import { isNullUndefined, isNullUndefinedOrEmpty } from '../../../../../../common/Helpers';
import { enum__COMPONENT_SIMPLE_COLOR_TYPE } from '../../../../../../common/Dictionaries';
import ChangeComponentType from '../Dataserie/ChangeComponentType';
import MainAppContext from '../../../../../../MainAppContext';
import BoardAppContext from '../../../../../../BoardAppContext';
import './style.css'
import SidePanelAddDataserieVariableValue from '../../BoardBox/BoardListNew/SidePanelAddDataserieVariableValue';
import SidePanelEditDataserieVariableValue from '../../BoardBox/BoardListNew/SidePanelEditDataserieVariableValue';
import SidePanelDeleteDataserieVariableValue from '../../BoardBox/BoardListNew/SidePanelDeleteDataserieVariableValue';
import SidePanelViewDataserieAditionalInfo from '../../BoardBox/BoardListNew/SidePanelViewDataserieAditionalInfo';
import SidePanelDataserieClose from '../../BoardElementTypeBox/DataserieClose/SidePanelDataserieClose';
import SidePanelViewDataserieVariableValue from '../../BoardBox/BoardListNew/SidePanelViewDataserieVariableValue';
function INFO_FINANCIAL(props) {
    const { t, i18n } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const contextBoard = useContext(BoardAppContext);

    const { 
      inputParam_BoardId = null,
      inputParam_Item = null,
      inputParam_Dataserie = null,
      inputParam_Component = null,
      inputParam_HidePanels = false,

      setBoardVariableDataserieValues = null,
    } = props;

    const getColor = (colorSuffix) => {
      switch (colorSuffix) {
        case 'a':
            return "#ECA700"
          case 'r':
            return "#d93b3b"
          case 'v':
            return "#25aa34"
        default:
          return "#C5C5C5"
      }
    }

    const [selectedDataserieToPanel, setSelectedDataserieToPanel] = useState(inputParam_Dataserie);
    const [isCloseDataseriesPanelOpen, setIsCloseDataseriesPanelOpen] = useState(false);
    const [isViewDataserieInfoPanelOpen, setIsViewDataserieInfoPanelOpen] = useState(false);
    const [isViewDataserieVariableValuePanelOpen, setIsViewDataserieVariableValuePanelOpen] = useState(false);
    const [isAddDataserieVariableValuePanelOpen, setIsAddDataserieVariableValuePanelOpen] = useState(false);
    const [isEditDataserieVariableValuePanelOpen, setIsEditDataserieVariableValuePanelOpen] = useState(false);
    const [isDeleteDataserieVariableValuePanelOpen, setIsDeleteDataserieVariableValuePanelOpen] = useState(false);
    const [calendarType, setCalendarType] = useState(null);

    const [inputParam_ItemFields] = useState(JSON.parse(inputParam_Component.htmlStyle).config)

    const getFieldDisplayValue = (inputParam_Item, _field) => {
      const fieldValue = inputParam_Item[_field.field];

      if (isNullUndefined(fieldValue)) {
        return t('no-data');
      }

      const displayValue = fieldValue.displayValue;
      const symbol = !isNullUndefined(_field.symbol) ? _field.symbol : "";

      if (isNullUndefinedOrEmpty(displayValue)) {
        if (!isNaN(inputParam_Item[_field.field])) {
          return `${Number(inputParam_Item[_field.field]).toLocaleString(i18n.language, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}${symbol}`;
        }
        else {
          return t('no-data');          
        }
      }

      if (!isNaN(displayValue)) {
        return `${Number(displayValue).toLocaleString(i18n.language, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}${symbol}`;
      }

      return `${displayValue}${symbol}`;
    };

    const onOpenPanel = (type, calendarType, dataSerie, setterCalendarType) => {
      switch (type) {
        case "view":
            setIsViewDataserieVariableValuePanelOpen(false)
            setIsAddDataserieVariableValuePanelOpen(false)
            setIsEditDataserieVariableValuePanelOpen(false)
            setIsDeleteDataserieVariableValuePanelOpen(false)
            setIsViewDataserieInfoPanelOpen(true)
            setIsCloseDataseriesPanelOpen(false)
            break;
        case "view2":
            setIsViewDataserieVariableValuePanelOpen(true)
            setIsAddDataserieVariableValuePanelOpen(false)
            setIsEditDataserieVariableValuePanelOpen(false)
            setIsDeleteDataserieVariableValuePanelOpen(false)
            setIsViewDataserieInfoPanelOpen(false)
            setIsCloseDataseriesPanelOpen(false)
            break;
        case "add":
            setIsViewDataserieVariableValuePanelOpen(false)
            setIsAddDataserieVariableValuePanelOpen(true)
            setIsEditDataserieVariableValuePanelOpen(false)
            setIsDeleteDataserieVariableValuePanelOpen(false)
            setIsViewDataserieInfoPanelOpen(false)
            setIsCloseDataseriesPanelOpen(false)
            break;
        case "edit":
            setIsViewDataserieVariableValuePanelOpen(false)
            setIsAddDataserieVariableValuePanelOpen(false)
            setIsEditDataserieVariableValuePanelOpen(true)
            setIsDeleteDataserieVariableValuePanelOpen(false)
            setIsViewDataserieInfoPanelOpen(false)
            setIsCloseDataseriesPanelOpen(false)
            break;
        case "delete":
            setIsViewDataserieVariableValuePanelOpen(false)
            setIsAddDataserieVariableValuePanelOpen(false)
            setIsEditDataserieVariableValuePanelOpen(false)
            setIsDeleteDataserieVariableValuePanelOpen(true)
            setIsViewDataserieInfoPanelOpen(false)
            setIsCloseDataseriesPanelOpen(false)
            break;
        case "close":
            setIsViewDataserieVariableValuePanelOpen(false)
            setIsAddDataserieVariableValuePanelOpen(false)
            setIsEditDataserieVariableValuePanelOpen(false)
            setIsDeleteDataserieVariableValuePanelOpen(false)
            setIsViewDataserieInfoPanelOpen(false)
            setIsCloseDataseriesPanelOpen(true)
            break;
        default:
            break;
      }

      setSelectedDataserieToPanel(dataSerie)
      setterCalendarType && setterCalendarType(calendarType)
    };

    const getComponentColorStyle = (_field) => {
      switch (inputParam_Item[_field.field].colorType) {
        case enum__COMPONENT_SIMPLE_COLOR_TYPE.BACK_COLOR:
            return {
              color: !isNullUndefinedOrEmpty(inputParam_Item[_field.field].color) ? "white" : "",
              fontSize: '16px',
              paddingLeft: (inputParam_Dataserie && inputParam_Component) && '20px',
            }
          case enum__COMPONENT_SIMPLE_COLOR_TYPE.ICON_COLOR:
            return {
              color: "",
              fontSize: '16px',
              paddingLeft: (inputParam_Dataserie && inputParam_Component) && '20px',
            }
          case enum__COMPONENT_SIMPLE_COLOR_TYPE.TEXT_COLOR:
            return {
              color: !isNullUndefinedOrEmpty(inputParam_Item[_field.field].color) ? getColor(inputParam_Item[_field.field].color) : "",
              fontSize: '16px',
              paddingLeft: (inputParam_Dataserie && inputParam_Component) && '20px',
            }
        default:
          return {}
      }
    }

    return (
            <div className='d-flex h-100 w-100'>
              {
                inputParam_Item && inputParam_ItemFields && inputParam_ItemFields.map((_field, index) => (
                  <Card key={index} className="h-100 w-100 p-0 m-0"
                    data-container-id={!isNullUndefined(inputParam_Component) ? inputParam_Component.containerId : ''}
                    data-component-id={!isNullUndefined(inputParam_Component) ? inputParam_Component.id : ''}
                  >
                      <Card.Body className='h-50 p-0 m-0 text-start rounded-top' style={{fontSize: "13px", fontWeight: "bolder", backgroundColor: "#e3e6f3", color: "darkblue"}}>
                        <TooltipHost content={ 
                                inputParam_Item[_field.field] !== undefined && inputParam_Item[_field.field] !== null &&
                                `${(!isNullUndefinedOrEmpty(inputParam_Item[_field.field].title) ? inputParam_Item[_field.field].title : t(`data-lang-lbl-field-${_field.name}`))}}`
                              }>
                            <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                              {
                                inputParam_Item[_field.field] !== null ?
                                <>
                                  { 
                                    !_field.usePartialTitle && inputParam_Item[_field.field] !== undefined &&
                                    <>
                                      {
                                      !isNullUndefinedOrEmpty(_field.customTitle) &&
                                      `${_field.customTitle}`
                                      }
                                      {
                                      isNullUndefinedOrEmpty(_field.customTitle) &&
                                      `${inputParam_Item[_field.field].titleAux !== undefined ?  `${inputParam_Item[_field.field].titleAux}` : t(`data-lang-lbl-field-${_field.name}`)}`
                                      }
                                    </>
                                  }
                                  { 
                                    _field.usePartialTitle && inputParam_Item[_field.field] !== undefined &&
                                    `${inputParam_Item[_field.field].titleAux !== undefined ?  `${inputParam_Item[_field.field].titleAux} ${t(`data-lang-lbl-field-${_field.name}`)}` : ''}`
                                  }
                                </> :
                                <>{t(`data-lang-lbl-field-${_field.name}`)}</>
                              }
                            </div>
                        </TooltipHost>
                      </Card.Body>
                      {
                        inputParam_Item[_field.field] !== undefined && inputParam_Item[_field.field] !== null ?
                        <Card.Body className={`h-50 m-0 p-0 pt-0 rounded-bottom text-center ${(inputParam_Item[_field.field].colorType === enum__COMPONENT_SIMPLE_COLOR_TYPE.BACK_COLOR? 'variable-value-color-' + inputParam_Item[_field.field].color : '')}` }>
                          <Row className="m-0 p-0">
                            <Col className='p-0 m-0'>
                              <b style={inputParam_Item[_field.field].color === t('no-data') ? {} : getComponentColorStyle(_field)}>
                                { getFieldDisplayValue(inputParam_Item, _field) } 
                              </b>
                              {
                                inputParam_Item[_field.field].colorType ===  enum__COMPONENT_SIMPLE_COLOR_TYPE.ICON_COLOR &&
                                <Icon iconName='CircleFill' styles={{ root: { color: getColor(inputParam_Item[_field.field].color) } }} />
                              }
                            </Col>
                            <Col className="col-auto mx-auto me-auto p-0 pe-2">
                              {
                                (inputParam_Dataserie && inputParam_Component) && index === 0 && !inputParam_HidePanels &&
                                <ChangeComponentType
                                  inputParam_OnChangeRowDisplayType={null}
                                  inputParam_SetCalendarType={setCalendarType}
                                  inputParam_OnChangeRowAggregationTime={null}
                                  inputParam_OnOpenPanel={onOpenPanel}
                                  inputParam_Component={inputParam_Component}
                                  inputParam_DataSerie={inputParam_Dataserie}
                                  inputParam_OnSelectSerieToCompareOnChart={null}
                                  inputParam_OnChartDataBindClearCompareClick={null}
                                  inputParam_SelectedDataserieToPanel={selectedDataserieToPanel}
                                  inputParam_HideAggregationButtons={true}
                                  inputParam_ShowOnlyInfoView={true}
                                  inputParam_ClassName="p-0 m-0 h-100"
                                  inputParam_ClassNameParent="h-100 pb-1"
                                />
                              }
                              {
                                  selectedDataserieToPanel !== null && calendarType !== null &&
                                  <>
                                      <SidePanelViewDataserieVariableValue
                                          inputParam_ElementId={selectedDataserieToPanel.elementId}
                                          inputParam_SetterIsPanelOpen={setIsViewDataserieVariableValuePanelOpen}
                                          inputParam_ElementType={calendarType}
                                          inputParam_SetCalendarType={setCalendarType}
                                          inputParam_IsPanelOpen={isViewDataserieVariableValuePanelOpen}
                                          inputParam_DataSerie={selectedDataserieToPanel}
                                          inputParam_BoardId={inputParam_BoardId}
                                      />
                                      <SidePanelAddDataserieVariableValue
                                          inputParam_ElementId={selectedDataserieToPanel.elementId}
                                          inputParam_SetterIsPanelOpen={setIsAddDataserieVariableValuePanelOpen}
                                          inputParam_ElementType={calendarType}
                                          inputParam_SetCalendarType={setCalendarType}
                                          inputParam_IsPanelOpen={isAddDataserieVariableValuePanelOpen}
                                          inputParam_DataSerie={selectedDataserieToPanel}
                                          inputParam_BoardId={inputParam_BoardId}
                                      />
                                      <SidePanelEditDataserieVariableValue
                                          inputParam_SetterIsPanelOpen={setIsEditDataserieVariableValuePanelOpen}
                                          inputParam_ElementType={calendarType}
                                          inputParam_IsPanelOpen={isEditDataserieVariableValuePanelOpen}
                                          inputParam_DataSerie={selectedDataserieToPanel}
                                          inputParam_BoardId={inputParam_BoardId}

                                          //[#NEW#]
                                          inputParam_ElementId={selectedDataserieToPanel.elementId}
                                      />
                                      <SidePanelDeleteDataserieVariableValue
                                          inputParam_SetterIsPanelOpen={setIsDeleteDataserieVariableValuePanelOpen}
                                          inputParam_ElementType={calendarType}
                                          inputParam_IsPanelOpen={isDeleteDataserieVariableValuePanelOpen}
                                          inputParam_DataSerie={selectedDataserieToPanel}
                                          inputParam_BoardId={inputParam_BoardId}
                                      />
                                  </>
                              }
                              {
                                  selectedDataserieToPanel !== null && isViewDataserieInfoPanelOpen &&
                                  <SidePanelViewDataserieAditionalInfo
                                      inputParam_SetterIsPanelOpen={setIsViewDataserieInfoPanelOpen}
                                      inputParam_IsPanelOpen={isViewDataserieInfoPanelOpen}
                                      inputParam_DataSerie={selectedDataserieToPanel}
                                      inputParam_SetterDataSerie={setSelectedDataserieToPanel}
                                      inputParam_BoardId={inputParam_BoardId}
                                  />
                              }
                            </Col>
                          </Row>
                        </Card.Body> :
                        <Card.Body className={`h-50 m-0 p-0 pt-1 rounded-bottom text-center` }>
                          <Row className="m-0 p-0">
                            <Col>
                              <b>
                                {`${inputParam_Item[_field.field] !== undefined && inputParam_Item[_field.field] !== null ? (!isNaN(inputParam_Item[_field.field].displayValue) ? parseFloat(inputParam_Item[_field.field].displayValue.toFixed(2)).toLocaleString(i18n.language) + (_field.symbol !== null && _field.symbol !== undefined ? _field.symbol : "") : (isNullUndefinedOrEmpty(inputParam_Item[_field.field].displayValue) ? t('no-data') : inputParam_Item[_field.field].displayValue)) : t('no-data')} `}
                              </b>
                            </Col>
                            <Col className="col-auto mx-auto me-auto p-0 pe-2">
                              {
                                (inputParam_Dataserie && inputParam_Component) && index === 0 &&
                                <ChangeComponentType
                                  inputParam_OnChangeRowDisplayType={null}
                                  inputParam_SetCalendarType={setCalendarType}
                                  inputParam_OnChangeRowAggregationTime={null}
                                  inputParam_OnOpenPanel={onOpenPanel}
                                  inputParam_Component={inputParam_Component}
                                  inputParam_DataSerie={inputParam_Dataserie}
                                  inputParam_OnSelectSerieToCompareOnChart={null}
                                  inputParam_OnChartDataBindClearCompareClick={null}
                                  inputParam_SelectedDataserieToPanel={selectedDataserieToPanel}
                                  inputParam_HideAggregationButtons={true}
                                  inputParam_ShowOnlyInfoView={true}
                                  inputParam_ClassName="p-0 m-0 h-100"
                                  inputParam_ClassNameParent="h-100 pb-1"
                                />
                              }
                              {
                                  selectedDataserieToPanel !== null && calendarType !== null &&
                                  <>
                                      <SidePanelViewDataserieVariableValue
                                          inputParam_ElementId={selectedDataserieToPanel.elementId}
                                          inputParam_SetterIsPanelOpen={setIsViewDataserieVariableValuePanelOpen}
                                          inputParam_ElementType={calendarType}
                                          inputParam_SetCalendarType={setCalendarType}
                                          inputParam_IsPanelOpen={isViewDataserieVariableValuePanelOpen}
                                          inputParam_DataSerie={selectedDataserieToPanel}
                                          inputParam_BoardId={inputParam_BoardId}
                                      />
                                      <SidePanelAddDataserieVariableValue
                                          inputParam_ElementId={selectedDataserieToPanel.elementId}
                                          inputParam_SetterIsPanelOpen={setIsAddDataserieVariableValuePanelOpen}
                                          inputParam_ElementType={calendarType}
                                          inputParam_SetCalendarType={setCalendarType}
                                          inputParam_IsPanelOpen={isAddDataserieVariableValuePanelOpen}
                                          inputParam_DataSerie={selectedDataserieToPanel}
                                          inputParam_BoardId={inputParam_BoardId}
                                      />
                                      <SidePanelEditDataserieVariableValue
                                          inputParam_SetterIsPanelOpen={setIsEditDataserieVariableValuePanelOpen}
                                          inputParam_ElementType={calendarType}
                                          inputParam_IsPanelOpen={isEditDataserieVariableValuePanelOpen}
                                          inputParam_DataSerie={selectedDataserieToPanel}
                                          inputParam_BoardId={inputParam_BoardId}

                                          inputParam_ElementId={selectedDataserieToPanel.elementId}
                                          //[#NEW#]
                                          setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                                      />
                                      <SidePanelDeleteDataserieVariableValue
                                          inputParam_SetterIsPanelOpen={setIsDeleteDataserieVariableValuePanelOpen}
                                          inputParam_ElementType={calendarType}
                                          inputParam_IsPanelOpen={isDeleteDataserieVariableValuePanelOpen}
                                          inputParam_DataSerie={selectedDataserieToPanel}
                                          inputParam_BoardId={inputParam_BoardId}
                                      />
                                  </>
                              }
                              {
                                  selectedDataserieToPanel !== null && isViewDataserieInfoPanelOpen &&
                                  <SidePanelViewDataserieAditionalInfo
                                      inputParam_SetterIsPanelOpen={setIsViewDataserieInfoPanelOpen}
                                      inputParam_IsPanelOpen={isViewDataserieInfoPanelOpen}
                                      inputParam_DataSerie={selectedDataserieToPanel}
                                      inputParam_SetterDataSerie={setSelectedDataserieToPanel}
                                      inputParam_BoardId={inputParam_BoardId}
                                  />
                              }
                              {
                                selectedDataserieToPanel !== null && isCloseDataseriesPanelOpen &&
                                <SidePanelDataserieClose
                                    inputParam_BoardId={inputParam_BoardId}
                                    inputParam_ElementId={selectedDataserieToPanel.elementId}
                                    inputParam_DataSerieList={[selectedDataserieToPanel]}
                                    inputParam_IsPanelOpen={isCloseDataseriesPanelOpen}
                                    inputParam_SetterIsPanelOpen={setIsCloseDataseriesPanelOpen}
                                />
                              }
                            </Col>
                          </Row>
                        </Card.Body>
                      }
                  </Card>
                )) 
              }
            </div>
           );
}

INFO_FINANCIAL.propTypes = {
  inputParam_Item: PropTypes.object.isRequired,
};

export default INFO_FINANCIAL;